<ng-container *transloco="let t; read: 'home.calculator'">
  <psc-section-title
    [title]="t('calculator.monthly_result')"
    alignment="left"
    size="normal"
    [lineWidthPercentage]="100"
    [lineThickness]="2"></psc-section-title>

  <div class="flex flex-col gap-10 justify-center items-stretch w-full">
    <psc-monthly-chart
      (monthChanged)="monthChanged($event)"
      [solarCalculatorResult]="solarCalculatorResult"></psc-monthly-chart>
      <psc-monthly-values
        [selectedMonth]="selectedMonth"
        [solarCalculatorResult]="solarCalculatorResult"></psc-monthly-values>
  </div>
</ng-container>
